/* eslint-disable no-param-reassign */
import dayjs from 'dayjs';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { post } from '../../../services/GenesisApi';
import { AUDIT_API } from '../../../constants/Audit';

interface IData {
  data: [];
  totalRecords: number;
}

export const getAuditDataAdvSearch = createAsyncThunk(
  'auditData/getAuditDataAdvSearch',
  async (auditLogsParam: any) => {
    const { auditDate, requestBody } = auditLogsParam;
    return post(`${AUDIT_API}?fromPeriod=${auditDate}`, requestBody)
      .then((response) => {
        return response.data || [];
      })
      .catch((error) => {
        throw error;
      });
  }
);

export interface IAuditState {
  auditData: IData;
  isLoading: boolean;
}

export const initialState: IAuditState = {
  auditData: {
    data: [],
    totalRecords: 0,
  },
  isLoading: false,
};

const AuditData = createSlice({
  name: 'auditActions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditDataAdvSearch.pending, (state: IAuditState) => {
        state.isLoading = true;
      })
      .addCase(
        getAuditDataAdvSearch.fulfilled,
        (state: IAuditState, { payload }: PayloadAction<any>) => {
          state.auditData.data = payload?.audits.map((item) => ({
            ...item,
            auditTimeStampInGmt: dayjs(item.auditTimeStampInGmt).format(
              'ddd DD-MMM-YY hh:mm:ss A'
            ),
          }));
          state.auditData.totalRecords = payload?.count;

          state.isLoading = false;
        }
      )
      .addCase(getAuditDataAdvSearch.rejected, (state: IAuditState) => {
        state.isLoading = false;
      });
  },
});

export const auditActions = AuditData.actions;
export default AuditData.reducer;
